import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-navIcon3",
  "use": "icon-navIcon3-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-navIcon3\"><path fill-rule=\"evenodd\" d=\"M10 16.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M8.12 6.112a.447.447 0 1 0-.66.603l1.526 1.67H7.053a.447.447 0 0 0 0 .893h2.5v1.525h-2.5a.447.447 0 1 0 0 .894h2.5v2.576a.447.447 0 0 0 .894 0v-2.576h2.5a.447.447 0 0 0 0-.894h-2.5V9.278h2.5a.447.447 0 0 0 0-.894h-1.932l1.526-1.67a.447.447 0 0 0-.66-.602L10 8.169z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol